import type { SkillTemplate } from './issue-log-xref.js';
import { browserTestingRenderCurrent } from './browser-testing-current.js';
import { browserTestingRenderV1_0_0 } from './browser-testing-v1-0-0.js';

export const browserTestingTemplate: SkillTemplate = {
  name: 'browser-testing',
  description: 'Use the Canary CLI to control a browser for testing web applications',
  version: '1.1.0',
  render: browserTestingRenderCurrent,
  previousVersions: {
    '1.0.0': browserTestingRenderV1_0_0,
  },
};
